module.exports = __webpack_public_path__ + "img/lb1.f131207a.svg";